var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 231,
    viewBox: "0 0 231 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.875 3.0625H115.5C111.241 3.06675 107.158 4.76041 104.147 7.77179C101.135 10.7832 99.4418 14.8663 99.4375 19.125V99.4375H19.125C14.8663 99.4418 10.7832 101.135 7.77179 104.147C4.76041 107.158 3.06675 111.241 3.0625 115.5V227.938H227.938V19.125C227.933 14.8663 226.24 10.7832 223.228 7.77179C220.217 4.76041 216.134 3.06675 211.875 3.0625ZM59.2812 211.875V155.656H91.4062V211.875H59.2812ZM211.875 211.875H107.469V147.625C107.469 145.495 106.623 143.452 105.116 141.946C103.61 140.44 101.568 139.594 99.4375 139.594H51.25C49.12 139.594 47.0772 140.44 45.5711 141.946C44.0649 143.452 43.2188 145.495 43.2188 147.625V211.875H19.125V115.5H115.5V19.125H211.875V211.875Z",
    fill: "#D4582A",
    stroke: "#D4582A",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.562 54.75H130.062V56.25V72.3125V73.8125H131.562H147.625H149.125V72.3125V56.25V54.75H147.625H131.562ZM179.75 54.75H178.25V56.25V72.3125V73.8125H179.75H195.812H197.312V72.3125V56.25V54.75H195.812H179.75ZM131.562 102.938H130.062V104.438V120.5V122H131.562H147.625H149.125V120.5V104.438V102.938H147.625H131.562ZM179.75 102.938H178.25V104.438V120.5V122H179.75H195.812H197.312V120.5V104.438V102.938H195.812H179.75ZM131.562 151.125H130.062V152.625V168.688V170.188H131.562H147.625H149.125V168.688V152.625V151.125H147.625H131.562ZM179.75 151.125H178.25V152.625V168.688V170.188H179.75H195.812H197.312V168.688V152.625V151.125H195.812H179.75Z",
    fill: "#D4582A",
    stroke: "#D4582A",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.c0e2cb1312a680ee338f8d787ee890d6.svg";
export { ForwardRef as ReactComponent };